// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/OrgChartComponent.js
import React, { useState, useEffect } from 'react';
import { OrganizationChart } from 'primereact/organizationchart';
import { SpeedDial } from 'primereact/speeddial';

// สไตล์เดิม
import styles from '../css/MemberMLM.module.scss';
import orgChartStyles from '../css/OrgChartComponent.module.scss';
import positionColors from '../data/OrgPositionsColor.json';

// Dialogs
import SponsorViewDialog from './mlmOrg/SponsorViewDialog';
import EditSponsorDialog from './mlmOrg/EditSponsorDialog';
import MessageDialog from './mlmOrg/MessageDialog';

// ฟังก์ชันและตัวจัดการภาษา
import { getSelectedLanguage } from '../api/api';         // ฟังก์ชันดึงภาษาที่ผู้ใช้เลือก
import { languageManager } from '../utils/loadLanguage'; // singleton สำหรับโหลด JSON ภาษาต่าง ๆ

const OrgChartComponent = ({ nodes, totalMembers, onNodeClick }) => {
    const [sponsorDialogVisible, setSponsorDialogVisible] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);

    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [editUserId, setEditUserId] = useState(null);

    const [messageDialogVisible, setMessageDialogVisible] = useState(false);
    const [messageUserId, setMessageUserId] = useState(null);

    // state สำหรับเก็บ text/string ที่โหลดจาก JSON
    const [t, setT] = useState({}); 

    // โหลดภาษาจาก JSON เมื่อคอมโพเนนต์ Mount
    useEffect(() => {
        async function loadLang() {
            const lang = getSelectedLanguage();   // เช่น 'en' หรือ 'th'
            await languageManager.loadLanguage(lang);
            // ดึงเฉพาะส่วน orgChartComponent
            setT(languageManager.translations.orgChartComponent || {});
        }
        loadLang();
    }, []);

    // -----------------------------
    // ฟังก์ชันเปิด Dialog โปรไฟล์
    const handleViewSponsor = (user_id) => {
        setSelectedUserId(user_id);
        setSponsorDialogVisible(true);
    };
    const hideSponsorDialog = () => {
        setSelectedUserId(null);
        setSponsorDialogVisible(false);
    };

    // -----------------------------
    // ฟังก์ชันเปิด Dialog Edit
    const handleEditClick = (user_id) => {
        setEditUserId(user_id);
        setEditDialogVisible(true);
    };
    const hideEditDialog = () => {
        setEditUserId(null);
        setEditDialogVisible(false);
    };

    // -----------------------------
    // ฟังก์ชันเปิด Dialog Message
    const handleMessageClick = (user_id) => {
        setMessageUserId(user_id);
        setMessageDialogVisible(true);
    };
    const hideMessageDialog = () => {
        setMessageUserId(null);
        setMessageDialogVisible(false);
    };

    // Template สำหรับ Node
    const nodeTemplate = (node) => {
        if (!node) return <div>{t.loadingData || "Loading..."}</div>;

        const { first_name, sur_name, position, user_id } = node.label || {};
        const bgColor = positionColors.positions[position]?.color || '#FFFFFF';

        // เมนู SpeedDial
        const items = [
            {
                label: t.openLoad || 'Open/Load',
                icon: () => (
                    <span
                        className="pi pi-search"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleViewSponsor(user_id);
                        }}
                    />
                ),
                command: () => handleViewSponsor(user_id),
                className: orgChartStyles.myAction
            },
            {
                label: t.mlm || 'MLM',
                icon: () => (
                    <span
                        className="pi pi-sitemap"
                        onClick={(e) => {
                            e.stopPropagation();
                            onNodeClick(user_id);
                        }}
                    />
                ),
                command: () => onNodeClick(user_id),
                className: orgChartStyles.myAction
            },
            {
                label: t.message || 'Message',
                icon: () => (
                    <span
                        className="pi pi-envelope"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleMessageClick(user_id);
                        }}
                    />
                ),
                command: () => handleMessageClick(user_id),
                className: orgChartStyles.myAction
            },
            {
                label: t.edit || 'Edit',
                icon: () => (
                    <span
                        className="pi pi-dollar"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleEditClick(user_id);
                        }}
                    />
                ),
                command: () => handleEditClick(user_id),
                className: orgChartStyles.myAction
            }
        ];

        return (
            <div className={orgChartStyles.orgChartContainer}>
                <div
                    className={orgChartStyles.nodeContainer}
                    style={{ backgroundColor: bgColor }}
                    onClick={() => onNodeClick(user_id)}
                >
                    <div><strong>{t.name || "Name:"}</strong> {first_name} {sur_name}</div>
                    <div><strong>{t.position || "Position:"}</strong> {position}</div>
                    <div><strong>{t.userID || "User ID:"}</strong> {user_id}</div>
                </div>

                <div className={orgChartStyles.speedDialContainer}>
                    <SpeedDial
                        buttonClassName={orgChartStyles["p-button-rounded"]}
                        model={items}
                        direction="down"
                        type="circle"
                        radius={70}
                        showIcon="pi pi-bars"
                        hideIcon="pi pi-times"
                        id={`speedDial_${user_id}`}
                    />
                </div>
            </div>
        );
    };

    return (
        <>
            {nodes ? (
                <div>
                    <OrganizationChart
                        value={nodes}
                        nodeTemplate={nodeTemplate}
                        className="mlm-chart"
                    />
                    <div className={styles["total-members"]}>
                        {t.totalMembers || "Total Members"}: {totalMembers}
                    </div>
                </div>
            ) : (
                <div>{t.loadingData || "Loading organization data..."}</div>
            )}

            {/* Dialog ดูโปรไฟล์ */}
            <SponsorViewDialog
                visible={sponsorDialogVisible}
                onHide={hideSponsorDialog}
                userId={selectedUserId}
            />

            {/* Dialog Edit */}
            <EditSponsorDialog
                visible={editDialogVisible}
                onHide={hideEditDialog}
                userId={editUserId}
            />

            {/* Dialog Message */}
            <MessageDialog
                visible={messageDialogVisible}
                onHide={hideMessageDialog}
                userId={messageUserId}
            />
        </>
    );
};

export default OrgChartComponent;
